import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "py-4" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("解除推荐人绑定")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("提交")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("取消")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_form, {
      ref: "formRef",
      rules: _ctx.rules,
      model: _ctx.member,
      "label-width": "120px"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_form_item, {
          label: "匿称",
          prop: "nickname"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: _ctx.member.nickname,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.member.nickname) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, {
          label: "手机号码",
          prop: "mobile"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: _ctx.member.mobile,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.member.mobile) = $event)),
              readonly: ""
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, {
          label: "馀额",
          prop: "balance"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: _ctx.member.balance,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.member.balance) = $event)),
              readonly: ""
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, {
          label: "积分",
          prop: "membership_point"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: _ctx.member.membership_point,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.member.membership_point) = $event)),
              readonly: ""
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, {
          label: "点数",
          prop: "point"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: _ctx.member.point,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.member.point) = $event)),
              readonly: ""
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, {
          label: "等级",
          prop: "level"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: _ctx.member.level,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.member.level) = $event)),
              readonly: ""
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, {
          label: "总经验值",
          prop: "exp"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: _ctx.member.exp,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.member.exp) = $event)),
              readonly: ""
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, {
          label: "升级经验值",
          prop: "next_level_exp"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: _ctx.member.next_level_exp,
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.member.next_level_exp) = $event)),
              readonly: ""
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, {
          label: "未开一般奖箱亏损",
          prop: "unopened_normal_boxes_loss"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: _ctx.member.unopened_normal_boxes_loss,
              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.member.unopened_normal_boxes_loss) = $event)),
              readonly: ""
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, {
          label: "黑名单",
          prop: "is_black"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_switch, {
              modelValue: _ctx.member.is_black,
              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.member.is_black) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, {
          label: "跳过隐藏",
          prop: "is_skip_hide"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_switch, {
              modelValue: _ctx.member.is_skip_hide,
              "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.member.is_skip_hide) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, { label: "推荐人" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              "model-value": _ctx.member.parent_nickname ? `${_ctx.member.parent_nickname}${_ctx.member.parent_mobile ? ` (${_ctx.member.parent_mobile})` : ''}` : '无',
              readonly: ""
            }, null, 8, ["model-value"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, { label: "邀请码" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: _ctx.member.promot_code,
              "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.member.promot_code) = $event)),
              readonly: ""
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, { label: "下线数" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              "model-value": _ctx.member.brother_count,
              readonly: ""
            }, null, 8, ["model-value"])
          ]),
          _: 1
        }),
        (_ctx.member.parent_id)
          ? (_openBlock(), _createBlock(_component_el_form_item, { key: 0 }, {
              default: _withCtx(() => [
                _createVNode(_component_el_button, {
                  type: "danger",
                  size: "small",
                  onClick: _ctx.onUnbindParent
                }, {
                  default: _withCtx(() => [
                    _hoisted_2
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        _createVNode(_component_el_form_item, null, {
          default: _withCtx(() => [
            _createVNode(_component_el_button, {
              type: "primary",
              onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.onSubmit(_ctx.formRef)))
            }, {
              default: _withCtx(() => [
                _hoisted_3
              ]),
              _: 1
            }),
            _createVNode(_component_el_button, { onClick: _ctx.onCancel }, {
              default: _withCtx(() => [
                _hoisted_4
              ]),
              _: 1
            }, 8, ["onClick"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["rules", "model"])
  ]))
}